<template>
    <div class="temp_eidtbox pop-up2">
        
        <div>
            <div class="temp_tit"><p>我的选书模板</p></div>
            <Row >
                 <Col :span="6" v-for="(item,i) in tagArr" :key="i" class="con"  @mouseleave.native="mouseleave">
                    <!--  -->
                    <!--  -->
                    <span class="edit_tep_btn">
                        <i class="el-icon-edit" @click="editNameFun(i)"></i>
                        <i class="el-icon-delete"  @click="delTempFun(item.gid)"></i>
                    </span>
                    <div class="item_c"  :class="{'hover':seen&&i==current}"   @mouseenter="mouseOver(i)" >
                        <p v-show="!item.editName" :title="item.name" >{{item.name}}</p>
                        <Input v-model="tagArr[i].name"  v-show="item.editName" @blur="changName(tagArr[i])"></Input> 
                    </div>
                    <div class="item_detail hover"  v-show="seen&&i==current">
                        <p v-if="item.pubname">出版社(包含):{{item.pubname}}</p>
                        <p v-if="item.notPubname">出版社(不包含):{{item.notPubname}}</p>
                        <p v-if="item.eqztf">中图法(等于):{{getXkfl(item.eqztf)}}</p>
                        <p v-if="item.notztf">中图法(不包含):{{getXkfl(item.notztf)}}</p>
                        <p v-if="item.ztf">中图法(包含):{{getXkfl(item.ztf)}}</p>
                        <p v-if="item.xkfl">学科分类:{{getXkfl(item.xkfl)}}</p> 
                        <p v-if="item.myfrom">码洋:{{item.myfrom}}元-{{item.myto}}元</p>
                        <p v-if="item.keyWord">关键词(包含):{{item.keyWord}}</p>
                        <p v-if="item.notKeyWord">关键词(不包含):{{item.notKeyWord}}</p>
                        <p v-if="item.eqKeyWord">关键词(等于):{{item.eqKeyWord}}</p>
                        <p v-if="item.zhuangj">装帧:{{item.zhuangj}}</p>
                        <p v-if="item.myfrom">尺寸:{{item.sizefrom}}cm-{{item.sizeto}}cm</p>
                        <p v-if="item.pageFrom">页码:{{item.pageFrom}}页-{{item.pageTo}}页</p>
                        <p v-if="item.hasCD != ''">光盘项:{{getHasCd(item.hasCD)}}</p>
                        <p v-if="item.useobj">读者类型:{{item.useobj}}</p>
                    </div>
                </Col> 
            </Row>
            <div class="temp_tit"><p>其他人在用的选书模板</p></div>
            <Row >
                 <Col :span="6" v-for="(item,i) in tagArrOther" :key="i" class="con"  @mouseleave.native="mouseleave1">
                    <span class="add_tep_btn" v-show="seen1&&i==current1" @click="addTepm(item)"><i class="el-icon-plus" >加入我的模板</i></span>
                    <div class="item_c"  :class="{'hover':seen1&&i==current1}"  @mouseenter="mouseOver1(i)" >
                        {{item.name}}
                    </div>
                    <div class="item_detail hover"  v-show="seen1&&i==current1">
                        <p v-if="item.pubname">出版社:{{item.pubname}}</p>
                        <p v-if="item.notPubname">出版社(不包含):{{item.notPubname}}</p>
                        <p v-if="item.eqztf">中图法(等于):{{getXkfl(item.notPubname)}}</p>
                        <p v-if="item.notztf">中图法(不包含):{{getXkfl(item.notPubname)}}</p>
                        <p v-if="item.ztf">中图法:{{getXkfl(item.notPubname)}}</p>
                        <p v-if="item.xkfl">学科分类:{{getXkfl(item.xkfl)}}</p> 
                        <p v-if="item.myfrom">码洋:{{item.myfrom}}元-{{item.myto}}元</p>
                        <p v-if="item.keyWord">关键词:{{item.keyWord}}</p>
                        <p v-if="item.notKeyWord">关键词(不包含):{{item.notKeyWord}}</p>
                        <p v-if="item.eqKeyWord">关键词(等于):{{item.eqKeyWord}}</p>
                        <p v-if="item.zhuangj">装帧:{{item.zhuangj}}</p>
                        <p v-if="item.myfrom">尺寸:{{item.sizefrom}}cm-{{item.sizeto}}cm</p>
                        <p v-if="item.pageFrom">页码:{{item.pageFrom}}页-{{item.pageTo}}页</p>
                         <p v-if="item.hasCD">光盘项:{{getHasCd(item.hasCD)}}</p>
                        <p v-if="item.useobj">读者类型:{{item.useobj}}</p>
                    </div>
                </Col> 
            </Row>
            <!-- <Row class="con">
                 <Col :span="6" v-for="(item,i) in tagArr" :key="i"  >
                    <div class="item_c"  @click="searchBook(item)">{{item.name}}</div>
                </Col> 
            </Row> -->

        </div>

    </div>
</template>
    
    <script>
        import {Row,Col,Input} from 'element-ui'
        import Axios from "@/api/diyaxios";
        import Cookies from 'js-cookie'

        export default {
            props: ['type'],
            components:{
                Row,Col,Input
            },
            data() {
                return {
                    tagArr:[],
                    seen:false,
                    current:0,
                    tagArrOther:[],
                    seen1:false,
                    current1:0,
                }
            },
            watch:{
            },
            created(){
                
            },
            computed:{

            },
            mounted() {
                this.getListArr('my');
                this.getListArr('other');
                
            },
            methods:{
                addTepm(objdata){
                    let vm = this,
                        url = "/template/action/save",
                        saveobj = Object.assign({}, objdata);
                        saveobj.orgGid = Cookies.get('orgGid');
                    delete saveobj.gid;
                    delete saveobj.orgId;
                    Axios.post(url, { params: saveobj },
                        {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    ).then(res => {
                        if(res.status){
                            this.$message({
                                message: "加入模板成功！",
                                type: "success",
                                duration:800
                            });
                            vm.getListArr('my');
                        }else{
                            this.$message({
                                message: res.msg,
                                type: "success",
                                duration:800
                            });
                        }
                    }).catch(err => {
                    });

                },
                editNameFun(index){//改编辑
                    this.$set(this.tagArr[index],'editName',true)
                },
                delTempFun(gid){//删除
                    let vm = this,
                        url = "/template/action/delete";
                    Axios.post(url, { params: { 
                            gid:gid
                        }},
                            {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }
                        ).then(res => {
                            this.$message({
                                message: "删除成功！",
                                type: "success",
                                duration:800
                            });
                            vm.getListArr('my');
                        }).catch(err => {
                    });
                },
                changName(item){
                    let vm = this,
                        url = "/template/action/rename";
                    Axios.post(url, { params: { 
                            gid:item.gid,
                            name:item.name
                        }},
                            {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }
                        ).then(res => {
                            if(res.status){
                                this.$message({
                                    message: "名称修改成功！",
                                    type: "success",
                                    duration:800
                                });
                                vm.getListArr('my');
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                    duration:800
                                });
                            }
                           
                        }).catch(err => {
                    });
                },
                searchBook(item){
                    this.$emit('submit',item);
                },
                mouseOver(index){
                    this.seen = true;
                    this.current = index;
                },
                mouseleave(){
                    this.seen = false;
                    this.current = null;
                },
                mouseOver1(index){
                    this.seen1 = true;
                    this.current1 = index;
                },
                mouseleave1(){
                    this.seen1 = false;
                    this.current1 = null;
                },
                getXkfl(val){
                    var str = '',
                    val = val || '',
                    valArr = val.split('|');
                    if(valArr && valArr.length > 0){
                        str = valArr[1]
                    }
                    return str
                },
                getHasCd(val){
                    var str = '';
                    if(val == '-1'){
                        str = '全部';
                    }else if(val == '1'){
                        str = '有';
                    }else if(val == '0'){
                        str = '无';
                    }
                    return str;
                },
                getListArr(type){
                    let vm = this,
                        url = "/template/action/search",
                        obj = {};
                    if(type == 'my'){
                        obj.orgId = Cookies.get('orgGid')
                    }else{
                        obj.notOrgId = Cookies.get('orgGid')
                    }
                    Axios.post(url, { params: obj},
                            {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }
                        ).then(res => {
                            // vm.tagArr = res.data || [];
                            vm[type=='my'?'tagArr':'tagArrOther'] = res.data || [];
                        }).catch(err => {
                    });
                },
               
            }
        }
    </script>
    
<style lang='scss'>
.temp_eidtbox{
    height: 600px;
    overflow-y: auto;
    .temp_tit{
        font-size: 22px;
        height: 22px;
        line-height: 22px;
        border-left: 5px solid #68c04a;
        padding-left: 8px;
    }
    .con{
        position: relative;
        .edit_tep_btn{
            position:absolute;
            right: 30px;
            top: 28px;
            i{
                cursor: pointer;
                margin-right: 10px;
            }
        }
        .add_tep_btn{
            position:absolute;
            right: 30px;
            top: 28px;
            cursor: pointer;
            color: #777;
        }
        .item_c{
            margin: 20px;
            border: 1px dashed #bbb;
            padding: 20px;
            background: #fff;
            height: 40px;
            line-height: 40px;
            p{
                overflow:hidden;  text-overflow:ellipsis; white-space:nowrap;
            }
            &.hover{
                background-color: #f0fbec;
            }
            .el-input__inner{
                height: 20px;
                 line-height: 20px;
            }
        }
        .item_detail{
            position: absolute;
            left: 0px;
            top: 80px;
            z-index: 100;
            margin: 20px;
            padding: 5px;
            border: 1px dashed #bbb;
            height: auto;
            width: 183px;
            p{
                font-size: 12px;
            }
            &.hover{
                background-color: #f0fbec;
            }
        }
    }
    
}
    
</style>


// WEBPACK FOOTER //
// src/views/getBook/editTemp.vue